exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-style__table___ZycYj{background:white;margin-top:10px}.table-style__thead___3n8IF{color:var(--header-color) !important;box-shadow:none !important;border-bottom:solid 1px #e9e9e9 !important}.table-style__th___2YPP0{padding:0.8rem 0rem !important;border-right:none  !important;cursor:var(--cursor) !important;flex:20 0 auto !important;outline:none !important}.table-style__td___2Ton2{border-right:none !important;padding:0.3rem var(--cell-side-padding) !important}.table-style__td___2Ton2:not(.table-style__td--autoheight___3_uqJ){padding:0 var(--cell-side-padding) !important;line-height:var(--row-height)}.table-style__tr___3aZfi{cursor:var(--cursor) !important;background:var(--background-default);color:var(--text-default)}.table-style__tr___3aZfi:not(.table-style__tr--autoheight___2IqV7){line-height:var(--row-height)}.table-style__tr___3aZfi.table-style__tr--selected___2SNAB{background:var(--background-selected);color:var(--text-selected)}.table-style__tr-group___3aK5U{border-bottom:solid 1px #e9e9e9 !important}.table-style__tbody___HWsUh{overflow:visible !important}\n", ""]);

// Exports
exports.locals = {
	"default-turquoise": "#0d91bd",
	"error-red": "#f9453e",
	"border-grey": "#e9e9e9",
	"white": "#fff",
	"default-blue": "#557eff",
	"glowing-blue": "#0d47ff",
	"text-black": "#555",
	"text-grey": "#778195",
	"disabled-grey-background": "#f9fafb",
	"disabled-light-grey-button": "#c2c2c2",
	"disabled-grey-text": "#a8a8a8",
	"success-green": "#03b571",
	"list-item-grey": "#f3f3f3",
	"outline-color": "#79c2db",
	"greyout": "#fafafa",
	"orange": "#f87748",
	"table": "table-style__table___ZycYj",
	"thead": "table-style__thead___3n8IF",
	"th": "table-style__th___2YPP0",
	"td": "table-style__td___2Ton2",
	"td--autoheight": "table-style__td--autoheight___3_uqJ",
	"tr": "table-style__tr___3aZfi",
	"tr--autoheight": "table-style__tr--autoheight___2IqV7",
	"tr--selected": "table-style__tr--selected___2SNAB",
	"tr-group": "table-style__tr-group___3aK5U",
	"tbody": "table-style__tbody___HWsUh"
};